function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, InputNumber } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var NewExam = function NewExam(_ref) {
  var handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    deptOptions = _useState8[0],
    setDeptOptions = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleBasePriceChange = function handleBasePriceChange(v) {
    form.setFieldsValue({
      ent_price: v.target.value,
      ins_price: v.target.value,
      lan_price: v.target.value
    });
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('department_id', values.department_id);
    formData.append('base_price', values.base_price);
    formData.append('ent_price', values.ent_price);
    formData.append('ins_price', values.ins_price);
    formData.append('lan_price', values.lan_price);
    axios.post(Common.baseApiUrl + 'addexam', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getdepartments').then(function (response) {
      if (response.data.status == 200) {
        response.data.departments.forEach(function (s) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: s.id,
              label: s.label
            }]);
          });
        });
        form.setFieldsValue({
          department_id: deptOptions
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom de l'acte/Produit",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            sm: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "base_price",
              label: "prix de base",
              onChange: handleBasePriceChange,
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {})
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            sm: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "ent_price",
              label: "prix soci\xE9t\xE9s",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {})
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            sm: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "ins_price",
              label: "prix assurances",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {})
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            sm: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "lan_price",
              label: "prix lanala",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {})
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "department_id",
        label: "Departements",
        children: /*#__PURE__*/_jsx(Select, {
          placeholder: "Choisir le service",
          options: deptOptions,
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          disabled: deptOptions.length == 0,
          loading: isFormLoading,
          type: "primary",
          children: "AJOUTER"
        })
      })]
    })]
  });
};
export default NewExam;